import { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { VideoResponsiveContainer } from 'common/video-responsive'
import { useVideoProgress } from 'mutations/lesson'
import { useLesson } from 'querys/lesson'
import { useRouter } from 'next/router'

function Youtube({ progress_time, id_youtube }) {
  const player = useRef(null)
  const { data: { course:  { slug }, lesson_navigation: { next } } } = useLesson()
  const videoProgress = useVideoProgress()
  const router = useRouter()

  useEffect(() => {
    const tag = document.createElement('script')
    tag.src = "https://www.youtube.com/iframe_api"
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    let interval

    function onPlayerReady(event) {
      const ytPlayer = event.target
      ytPlayer.playVideo()
      if (navigator?.platform === 'iPad' || navigator?.platform === 'iPhone') {
        setTimeout(() => {
          ytPlayer.playVideo()
        }, 1000)
      }
      const rate = localStorage.getItem('speed') || 1
      const rateValue = parseInt(rate, 10)
      ytPlayer.setPlaybackRate(rateValue)
      const volume = (localStorage.getItem('volume') * 100) || 100
      ytPlayer.setVolume(volume)
    }

    function onPlayerStateChange(event) {
      const ytPlayer = event.target
      if (event.data === window.YT.PlayerState.PLAYING) {
        interval = window.setInterval(async () => {
          const position = await ytPlayer.getCurrentTime()
          videoProgress.mutate(Math.trunc(position))
        }, 10000)
      }
      if (event.data === window.YT.PlayerState.PAUSED) {
        window.clearInterval(interval)
      }
      if (event.data === window.YT.PlayerState.ENDED) {
        window.clearInterval(interval)
        videoProgress.mutate(0)
        if (next?.slug) {
          router.push(
            '/aprender/[course]/[lesson_slug]',
            `/aprender/${slug}/${next?.slug}`,
          )
        } else {
          router.push(
            '/aprender/[course]',
            `/aprender/${slug}`,
          )
        }
      }
    }

    function onPlayerRateChange(event) {
      const rate = event.data
      if (rate === 1.75) {
        localStorage.setItem('speed', 1.5)
        return
      }
      if (rate === 0.25) {
        localStorage.setItem('speed', 0.5)
        return
      }
      localStorage.setItem('speed', rate)
    }

    function onYouTubeIframeAPIReady(YT) {
      player.current = new YT.Player('lesson_player', {
        videoId: id_youtube,
        // videoId: 'xxIYXjyXgmE',
        playerVars: {
          start: progress_time,
          playsinline: 1,
          showinfo: 0,
          modestbranding: 1,
          rel: 0,
          color: 'red',
          enablejsapi: 1,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
          onPlaybackRateChange: onPlayerRateChange,
        },
      })
    }

    const intervalYT = setInterval(() => {
      if (window.YT?.loaded) {
        onYouTubeIframeAPIReady(window.YT)
        clearInterval(intervalYT)
      }
    }, 100)
    return () => {
      clearInterval(interval)
      clearInterval(intervalYT)
      if (player.current) {
        player.current.removeEventListener('onReady', onPlayerReady)
        player.current.removeEventListener('onStateChange', onPlayerStateChange)
        player.current.removeEventListener('onPlaybackRateChange', onPlayerRateChange)
        player.current.destroy()
      }
    }
  }, [id_youtube])
  return (
    <VideoResponsiveContainer position="static">
      <div id="lesson_player" />
    </VideoResponsiveContainer>
  )
}

Youtube.propTypes = {
  token: PropTypes.string.isRequired,
  progress_time: PropTypes.number.isRequired,
  id_youtube: PropTypes.string.isRequired,
}

export default Youtube
